import { useState } from 'react';
import { useLocalization } from '../../contexts/LocalizationContext';
import productTypeService from '../../services/productTypeService';
import Modal from '../../components/Common/Modal';
import Input from '../../components/Common/Input';
import Button from '../../components/Common/Button';

const CreateProductTypeModal = ({ isOpen, onClose, onSuccess }) => {
  const { get, isRtl } = useLocalization();
  const [formData, setFormData] = useState({
    nameEn: '',
    nameAr: '',
    iconSvg: '',
    isActive: true,
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await productTypeService.create(formData);
      setFormData({ nameEn: '', nameAr: '', iconSvg: '', isActive: true });
      onSuccess();
    } catch (error) {
      console.error('Error creating product type:', error);
      const message = error.response?.data?.message || error.response?.data?.Message;
      alert(message || (isRtl ? 'حدث خطأ أثناء إنشاء نوع المنتج' : 'Error creating product type'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={get('add_product_type')}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            {get('cancel')}
          </Button>
          <Button variant="primary" onClick={handleSubmit} disabled={isLoading}>
            {get('save')}
          </Button>
        </>
      }
    >
      <form onSubmit={handleSubmit}>
        <Input
          label={isRtl ? 'الاسم (إنجليزي)' : 'Name (English)'}
          value={formData.nameEn}
          onChange={(e) => setFormData({ ...formData, nameEn: e.target.value })}
          required
        />
        <Input
          label={isRtl ? 'الاسم (عربي)' : 'Name (Arabic)'}
          value={formData.nameAr}
          onChange={(e) => setFormData({ ...formData, nameAr: e.target.value })}
          required
        />
        <div className="form-group">
          <label className="form-label">{isRtl ? 'SVG الأيقونة' : 'Icon SVG'}</label>
          <textarea
            className="form-textarea"
            value={formData.iconSvg}
            onChange={(e) => setFormData({ ...formData, iconSvg: e.target.value })}
            rows="4"
            placeholder={isRtl ? 'أدخل كود SVG للأيقونة' : 'Enter SVG code for icon'}
          />
        </div>
        <div className="form-group">
          <label className="form-label" style={{ display: 'flex', alignItems: 'center', gap: 'var(--sp-2)' }}>
            <input
              type="checkbox"
              checked={formData.isActive}
              onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
            />
            {isRtl ? 'نشط' : 'Active'}
          </label>
        </div>
      </form>
    </Modal>
  );
};

export default CreateProductTypeModal;
